import React, { useEffect, useState } from "react";
import axios from "../utils/axiosConfig";

const BuyerDetailModal = ({ show, dealId, onClose }) => {

  const [buyer, setBuyer] = useState(null);
  const [contacts, setContacts] = useState([]);

  useEffect(() => {

    if (show && dealId) {
      fetchBuyer();
    }

  }, [show, dealId]);

  const fetchBuyer = async () => {

    try {

      const res = await axios.get(`/buyers/details/${dealId}`);
   console.log(res.data)
      setBuyer(res.data);
      setContacts(res.data.contacts);

    } catch (err) {

      console.error(err);

    }

  };

  if (!show) return null;

  return (

    <div className="modal show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>

      <div className="modal-dialog modal-lg">

        <div className="modal-content">

          {/* HEADER */}

          <div className="modal-header">

            <h5 className="modal-title">
              Buyer Contact Details
            </h5>

            <button
              className="btn-close"
              onClick={onClose}
            ></button>

          </div>


          <div className="modal-body">

            {/* BUYER DETAILS */}

            <div className="card mb-3">

              <div className="card-header bg-light fw-bold">
                Buyer Details
              </div>

              <div className="card-body">

                <div className="row mb-2">

                  <div className="col-md-6">
                    <b>Name :</b> {buyer?.BuyerName}
                  </div>

                  <div className="col-md-6">
                    <b>Phone :</b> {buyer?.Phone}
                  </div>

                </div>

                <div className="row mb-2">

                  <div className="col-md-6">
                    <b>Mobile :</b> {buyer?.Mobile}
                  </div>

                  <div className="col-md-6">
                    <b>Email :</b> {buyer?.Email}
                  </div>

                </div>

                <div className="row">

                  <div className="col-md-12">
                    <b>Address :</b> {buyer?.Address}
                  </div>

                </div>

              </div>

            </div>


            {/* CONTACT TABLE */}

            <div className="card">

              <div className="card-header bg-light fw-bold">
                Buyer Contact Details
              </div>

              <div className="card-body p-0">

                <table className="table table-bordered table-sm mb-0">

                  <thead className="table-light">

                    <tr>

                      <th>Name</th>
                      <th>Contact No</th>
                      <th>Email</th>

                    </tr>

                  </thead>

                  <tbody>

                    {!contacts || contacts.length === 0 ? (

                      <tr>
                        <td colSpan="3" className="text-center">
                          No Contacts
                        </td>
                      </tr>

                    ) : (

                      contacts.map((c, i) => (

                        <tr key={i}>

                          <td>{c.ContactName}</td>
                          <td>{c.Phone}</td>
                          <td>{c.Email}</td>

                        </tr>

                      ))

                    )}

                  </tbody>

                </table>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  );

};

export default BuyerDetailModal;